import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';

export default function CGU() {
  const [siteLang, setSiteLang] = useState('FR');
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#fff', fontFamily: 'Arial, sans-serif', display: 'flex', flexDirection: 'column' }}>
      <Header siteLang={siteLang} setSiteLang={setSiteLang} />

      <section style={{ backgroundColor: '#0e0e0e', padding: '60px 24px', textAlign: 'center' }}>
        <p style={{ color: '#FF0066', fontSize: '11px', letterSpacing: '5px', margin: '0 0 12px', fontWeight: '700' }}>COMPIFY</p>
        <h1 style={{ color: '#fff', fontSize: '36px', fontWeight: '900', letterSpacing: '2px', margin: 0, textTransform: 'uppercase' }}>
          {siteLang === 'FR' ? 'CONDITIONS GÉNÉRALES D\'UTILISATION' : 'TERMS OF SERVICE'}
        </h1>
        <p style={{ color: '#555', fontSize: '12px', margin: '16px 0 0', letterSpacing: '1px' }}>
          {siteLang === 'FR' ? 'Dernière mise à jour : mars 2026' : 'Last updated: March 2026'}
        </p>
      </section>

      <section style={{ padding: '80px 24px', flex: 1 }}>
        <div style={{ maxWidth: '720px', margin: '0 auto' }}>

          {[
            {
              title: siteLang === 'FR' ? '1. Présentation du service' : '1. Service overview',
              content: siteLang === 'FR'
                ? 'Compify est un service en ligne gratuit permettant aux mannequins et aspirants mannequins de créer des cartes composites professionnelles. Le service est accessible sur compify.fr sans inscription préalable.'
                : 'Compify is a free online service allowing models and aspiring models to create professional composite cards. The service is accessible at compify.fr without prior registration.'
            },
            {
              title: siteLang === 'FR' ? '2. Accès et utilisation' : '2. Access and use',
              content: siteLang === 'FR'
                ? 'L\'accès à Compify est gratuit et ne nécessite pas de création de compte. En utilisant le service, vous acceptez les présentes conditions. Compify se réserve le droit de modifier ou d\'interrompre le service à tout moment.'
                : 'Access to Compify is free and does not require account creation. By using the service, you agree to these terms. Compify reserves the right to modify or discontinue the service at any time.'
            },
            {
              title: siteLang === 'FR' ? '3. Vos photos et contenus' : '3. Your photos and content',
              content: siteLang === 'FR'
                ? 'Vos photos sont traitées localement dans votre navigateur et ne sont jamais transmises à nos serveurs. Vous êtes seul responsable des contenus que vous utilisez. Vous garantissez détenir tous les droits nécessaires sur les photos utilisées.'
                : 'Your photos are processed locally in your browser and are never transmitted to our servers. You are solely responsible for the content you use. You guarantee that you hold all necessary rights to the photos used.'
            },
            {
              title: siteLang === 'FR' ? '4. Publicité' : '4. Advertising',
              content: siteLang === 'FR'
                ? 'Compify est financé par la publicité ciblée. Des annonces publicitaires peuvent être affichées dans l\'interface. Ces publicités sont sélectionnées pour être pertinentes pour notre audience de mannequins et professionnels de la mode.'
                : 'Compify is funded by targeted advertising. Advertisements may be displayed in the interface. These ads are selected to be relevant to our audience of models and fashion professionals.'
            },
            {
              title: siteLang === 'FR' ? '5. Propriété intellectuelle' : '5. Intellectual property',
              content: siteLang === 'FR'
                ? 'L\'ensemble du service Compify, incluant son interface, ses templates et son code, est protégé par le droit de la propriété intellectuelle. Toute reproduction, même partielle, est interdite sans autorisation préalable.'
                : 'The entire Compify service, including its interface, templates and code, is protected by intellectual property law. Any reproduction, even partial, is prohibited without prior authorization.'
            },
            {
              title: siteLang === 'FR' ? '6. Limitation de responsabilité' : '6. Limitation of liability',
              content: siteLang === 'FR'
                ? 'Compify est fourni "tel quel" sans garantie d\'aucune sorte. Compify ne saurait être tenu responsable des dommages directs ou indirects résultant de l\'utilisation du service ou de l\'impossibilité d\'y accéder.'
                : 'Compify is provided "as is" without warranty of any kind. Compify shall not be liable for direct or indirect damages resulting from the use of the service or the inability to access it.'
            },
            {
              title: siteLang === 'FR' ? '7. Droit applicable' : '7. Applicable law',
              content: siteLang === 'FR'
                ? 'Les présentes conditions sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.'
                : 'These terms are governed by French law. In case of dispute, French courts shall have exclusive jurisdiction.'
            },
            {
              title: siteLang === 'FR' ? '8. Contact' : '8. Contact',
              content: siteLang === 'FR'
                ? 'Pour toute question relative aux présentes conditions, vous pouvez nous contacter via le formulaire de contact disponible sur compify.fr/contact.'
                : 'For any questions regarding these terms, you can contact us via the contact form available at compify.fr/contact.'
            },
          ].map((section, i) => (
            <div key={i} style={{ marginBottom: '40px', paddingBottom: '40px', borderBottom: i < 7 ? '1px solid #f0f0f0' : 'none' }}>
              <h2 style={{ color: '#1A1A1A', fontSize: '16px', fontWeight: '700', margin: '0 0 14px', letterSpacing: '0.5px' }}>{section.title}</h2>
              <p style={{ color: '#666', fontSize: '14px', lineHeight: 1.8, margin: 0 }}>{section.content}</p>
            </div>
          ))}

          <div style={{ marginTop: '48px', padding: '24px', backgroundColor: '#f7f7f7', textAlign: 'center' }}>
            <p style={{ color: '#888', fontSize: '13px', margin: '0 0 16px' }}>
              {siteLang === 'FR' ? 'Des questions ?' : 'Any questions?'}
            </p>
            <button onClick={() => navigate('/contact')} style={{
              backgroundColor: '#FF0066', color: '#fff', border: 'none',
              padding: '12px 28px', fontSize: '11px', letterSpacing: '2px',
              fontWeight: '700', cursor: 'pointer'
            }}>
              {siteLang === 'FR' ? 'NOUS CONTACTER' : 'CONTACT US'}
            </button>
          </div>
        </div>
      </section>

      <Footer siteLang={siteLang} />
    </div>
  );
}